<div class="grid-container">
  <div class="grid-x grid-padding-x grid-padding-y grid-margin-x">
    @for (column of dashboard.columns; track column; let i = $index) {
      <div [ngClass]="getLayout(i)" class="widget-container cell">
        @for (widget of column; track widget) {
          @if (hasWidgetPermission(widget)) {
            <widget [widget]="widget"></widget>
          }
        }
      </div>
    }
  </div>
</div>
